import { ReloadKinds } from "./ReloadKinds";
import { SetTimingKinds } from "./SetTimingKinds";
import { ScreenKinds } from "./ScreenKinds";
import { InformationKinds } from "./InformationKinds";
import { ObjectKinds } from "./ObjectKinds";
import { ReloadDetailKinds } from "./ReloadDetailKinds";

export class HisItemParameter {
  constructor() {
  }

  public key: string = null;
  public displayName: string = null;
  public screenKind: ScreenKinds = ScreenKinds.None;
  public informationKind: InformationKinds = InformationKinds.All;
  public reloadKind: ReloadKinds = ReloadKinds.None;
  public updateTimingKind: SetTimingKinds = SetTimingKinds.None;
  public objectKind: ObjectKinds = ObjectKinds.NonDisplay;
  public isMultiSelect: boolean = true;
  public reloadDetailKind: ReloadDetailKinds = ReloadDetailKinds.Everytime;
  public isInstitutionSelect: boolean = false;

  public get isRequireSelectDialog(): boolean {
    return this.screenKind && (this.screenKind !== ScreenKinds.None);
  }

  clone(): HisItemParameter {
    const cloned = new HisItemParameter();
    cloned.key = this.key;
    cloned.displayName = this.displayName;
    cloned.screenKind = this.screenKind;
    cloned.informationKind = this.informationKind;
    cloned.reloadKind = this.reloadKind;
    cloned.updateTimingKind = this.updateTimingKind;
    cloned.objectKind = this.objectKind;
    cloned.isMultiSelect = this.isMultiSelect;
    cloned.reloadDetailKind = this.reloadDetailKind;
    cloned.isInstitutionSelect = this.isInstitutionSelect;
    return cloned;
  }
}
